export default {"src":"/_next/static/image/public/images/ic_no_fav_doctor.35a2047a1e2bb11a3ca8c6174742f81d.svg","height":147,"width":129};